export const setLanguage = lang => ({
  type: 'SET_LANGUAGE',
  lang: lang
})
